import React from "react"
import ProductListingItem from './ProductListingItem';
import styled from '@emotion/styled';
import { selectTheme, breakpoints, lightThemeColors } from '../../util/styles';

const ProductListingContainer = (props) => {
  return (
    <Container>
      {props.props.edges.map(({ node: product }) => (
          retriveProductItems(product)
        )
      )
      }
    </Container>
  )
};

let theme;
if (typeof window === 'undefined') {
  theme = lightThemeColors;
} else {
  theme = selectTheme(window);
}

function retriveProductItems(product) {
  if(product.fields){
    return <ProductListingItem key={product.fields.slug} product={product} theme={theme}/>
  }
  else{
    return <div/>
  }


}


const Container = styled(`div`)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px;

  @media (min-width: ${breakpoints.desktop}px) {
    flex-direction: row;
    flex-wrap: wrap;
    padding: 16px;
  }
`;


export default ProductListingContainer;
